import React, { ReactNode } from "react";
import { withStyles } from "@material-ui/core";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import useWindowResizeListener from "hooks/useWindowResizeListener";
import style from "style";
import classNames from "classnames";

const TITLE_DEFAULT_COLOR = "#b2006f";
const SUBTEXT_DEFAULT_COLOR = "#542785";
const BannerHeaderText = ({
  classes,
  headerText,
  subText,
  title_color,
  subtext_color,
}): ReactNode => {
  const { isMobile } = useWindowResizeListener();
  const titleColor = (): string => {
    if (isMobile) {
      return TITLE_DEFAULT_COLOR;
    }
    return title_color !== "" ? `#${title_color}` : "#b2006f";
  };

  const subtextColor = (): string => {
    if (isMobile) {
      return SUBTEXT_DEFAULT_COLOR;
    }
    return subtext_color !== "" ? `#${subtext_color}` : "#542785";
  };

  return (
    <div
      className={classNames(classes.bannerText, "flex-direction-column")}
      style={{ textAlign: "center" }}
    >
      <div
        style={{
          color: titleColor(),
          fontSize: 29,
          fontWeight: "600",
        }}
        dangerouslySetInnerHTML={{
          __html: headerText,
        }}
      />

      <div
        style={{ color: subtextColor(), fontSize: 29, fontWeight: "600" }}
        dangerouslySetInnerHTML={{
          __html: subText,
        }}
      />
    </div>
  );
};

export default withStyles(style)(BannerHeaderText);
